module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/telegram-badge-5cb8adcddb5cbababebf21cae13b2bf2.svg";